var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"check-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24"}},[_c('path',{attrs:{"d":"M400-304 240-464l56-56 104 104 264-264 56 56-320 320Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }